import { useGetSummaryQuery } from "@services/api/notifications";

const POLL_MS = 45_000;

export function useNotificationsPoller() {
    return useGetSummaryQuery(undefined, {
        pollingInterval: POLL_MS,
        skipPollingIfUnfocused: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
    });
}
